export const keytipAriaDescription = "j1GxKe";
export default {keytipAriaDescription};